import React from 'react';
import {View} from 'react-native';
import {Image} from '@rneui/themed';
import {observer} from 'mobx-react-lite';

import {
  BANNER_ASPECT_RATIO_MOBILE,
  BANNER_ASPECT_RATIO_WEB,
  BANNER_DESKTOP_MAX_HEIGHT,
  BANNER_DESKTOP_MAX_WIDTH,
} from '../../../components/HomepageCarousel/constants';
import {useWebScreenDimensions} from '../../../hooks/useWebScreenDimensions';
import {useStores} from '../../../stores/use-stores';
import {brandRewardsCopy} from '../../../utils/rewards';
import TitleLine from '../TitleLine';

type PromotionsProps = {
  onSeeAllPress?: () => void;
};

/**
 * Promotions static image for rewards tab
 */
function Promotions({onSeeAllPress}: PromotionsProps) {
  const {loyaltyInformationStore} = useStores();
  const {isWebDesktopScreen} = useWebScreenDimensions();

  const image = isWebDesktopScreen
    ? loyaltyInformationStore.information.RewardsPagePromotions.data?.imageDesktop
    : loyaltyInformationStore.information.RewardsPagePromotions.data?.image;

  return (
    <View>
      <TitleLine
        title={brandRewardsCopy.promotionsTitle.toUpperCase()}
        onSeeAllPress={onSeeAllPress}
      />
      <Image
        onPress={onSeeAllPress}
        containerStyle={{
          width: '100%',
          aspectRatio: isWebDesktopScreen ? BANNER_ASPECT_RATIO_WEB : BANNER_ASPECT_RATIO_MOBILE,
          flex: 1,
          borderRadius: 10,
          ...(isWebDesktopScreen
            ? {
                maxHeight: BANNER_DESKTOP_MAX_HEIGHT,
                maxWidth: BANNER_DESKTOP_MAX_WIDTH,
                alignSelf: 'center',
              }
            : {}),
        }}
        source={{uri: image?.url}}
      />
    </View>
  );
}

export default observer(Promotions);
